import type { SortState } from "./list-sort";

/** A clickable, sortable table header cell. `col` must match the backend sort key. */
export function SortTh({
  label,
  col,
  sort,
  onSort,
}: {
  label: string;
  col: string;
  sort: SortState | null;
  onSort: (col: string) => void;
}) {
  const active = sort?.by === col;
  const arrow = active ? (sort!.dir === "asc" ? " ▲" : " ▼") : "";
  return (
    <th
      className={active ? "sort-th sort-th-active" : "sort-th"}
      role="button"
      tabIndex={0}
      aria-sort={active ? (sort!.dir === "asc" ? "ascending" : "descending") : "none"}
      onClick={() => onSort(col)}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          onSort(col);
        }
      }}
    >
      {label}
      <span className="sort-arrow">{arrow}</span>
    </th>
  );
}

/** A "from"/"to" date-range filter pair. */
export function DateRange({
  from,
  to,
  onFrom,
  onTo,
  label = "Registered",
}: {
  from: string;
  to: string;
  onFrom: (v: string) => void;
  onTo: (v: string) => void;
  label?: string;
}) {
  return (
    <div className="date-range">
      <span className="date-range-label">{label}:</span>
      <input
        type="date"
        className="search-input date-input"
        value={from}
        onChange={(event) => onFrom(event.target.value)}
        aria-label={`${label} from date`}
        title="From date"
      />
      <span className="date-range-sep">→</span>
      <input
        type="date"
        className="search-input date-input"
        value={to}
        onChange={(event) => onTo(event.target.value)}
        aria-label={`${label} to date`}
        title="To date"
      />
      {from || to ? (
        <button
          type="button"
          className="secondary-btn date-clear"
          onClick={() => {
            onFrom("");
            onTo("");
          }}
        >
          Clear
        </button>
      ) : null}
    </div>
  );
}
